import {
  accountsService,
  targetGroupService,
  utilities,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

export class AvailableTargetGroupsViewModel {

  /** @type {{ type: 'new-target-group' } | { type: 'new-target-group-route', target }} */
  modal = null;

  /** @type {import('./RoutingPlansViewModel').RoutingPlansViewModel} */
  context = null;

  isLoading = false;
  isRefreshingTargetGroups = false;

  targetGroups = [];
  hasAnyGroup = false;

  initialize(ctx) {
    this.context = ctx;

    this._loadTargetGroups(false);

    return this;
  }

  closeModal = () => {
    this.modal = null;
  };

  openNewTargetGroupModal = () => {
    this.modal = { type: 'new-target-group' };
  };

  openNewTargetGroupRouteModal = (target) => {
    this.modal = { type: 'new-target-group-route', target };
  };

  refreshTargetGroups = () => {
    this.isRefreshingTargetGroups = true;
    try {
      this._loadTargetGroups();
    } finally {
      setTimeout(() => {
        this.isRefreshingTargetGroups = false;
      }, 600);
    }
  };

  async _loadTargetGroups(silent = true) {
    if (!silent) {
      this.isLoading = true;
    }

    try {
      const response = await targetGroupService.getTargetGroups(accountsService.currentAccountId);
      /** @type {any[]} */
      const items = response?.data?.targetGroups || [];
      this.hasAnyGroup = items.length > 0;

      // this.targetGroups = $filter('notInCampaignRoutes')(response.data.targetGroups, vm.routeContainerRoutes, 'group');
      this.targetGroups = this.context.routeContainer?.routes
        ? items.filter(target => this.context.routeContainer.routes.every(route => route.callTargetGroup?.id !== target.id))
        : items;

    } catch (error) {
      console.error('_loadTargetGroups ERROR:', error);
      utilities.errorHandler(error);
    } finally {
      this.isLoading = false;
    }

  }
}
